export class Address {
  addressid: string;
  street: string;
  number: string;
  zip: string;
  city: string;
  lat?: string;
  lng?: string;
  country?: string;
  company?: string;
  boxNumber?: string;
  apartmentNumber?: string;

  constructor() {
    this.street = '';
    this.number = '';
    this.zip = '';
    this.city = '';
    this.boxNumber = '';
    this.apartmentNumber = '';
  }
}

export class AddressDB {
  AddressId: string;
  Street: string;
  Number: string;
  PostalCode: string;
  City: string;
  Latitude: string;
  Longitude: string;
  Country: string;
  VatNumber: string;
  BoxNumber: string;
  ApartmentNumber: string;
  CompanyName: string;
}
